module.exports = __webpack_public_path__ + "static/img/public.8959c33.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/public.png
// module id = u5uI
// module chunks = 1